import { DepartmentModel } from 'types/models/DepartmentModel';
import { Department } from 'types/Project/Department';

export const mapDepartmentModelToDepartments = (departmentModels: DepartmentModel[]): Department[] =>
  departmentModels.reduce<Department[]>(
    (acc, { id, name, description }) => (id ? [...acc, { id, name, description }] : acc),
    [],
  );
